type DottedLabelProps = {
  children: React.ReactNode;
};

/**
 * Dotted underline marking a label that carries a tooltip. Type is inherited so
 * table headers stay at their smaller label size while KPI labels stay at 14px.
 */
export function DottedLabel({ children }: DottedLabelProps) {
  return (
    <span className="border-b border-dotted border-[#757575] text-[#333]">
      {children}
    </span>
  );
}
